export const CARD_NAMES = {
    TOP_TEN_HOLDINGS: 'Top 10 Holdings',
    TOP_TEN_ISSUERS: 'Top 10 Issuers',
    TOP_TEN_GUARANTORS: 'Top 10 Guarantors',
    ALL_HOLDINGS: 'All Holdings',
    TOP_TEN_HOLDINGS_BOND: 'Top 10 Holdings Bond',
    BOND_MATURITY: 'Bond Maturity',
    GEOGRAPHICAL_EXPOSURE: 'Geographical Exposure',
    SECTOR_ALLOCATION: 'Sector Allocation',
    PERFORMANCE_CHART: 'Performance Comparison Chart',
    AVERAGE_ANNUAL_CHART: 'Average Annual Total Returns',
    ETF_AVERAGE_ANNUAL_CHART: 'Average Annual Returns',
    CALENDAR_YEAR_CHART: 'Calendar Year Total Returns',
    DAY_YIELD: 'Day Yield',
    DAYS_PREMIUM_DISCOUNT: 'Days at Premium/Discount to Nav',
    FUND_SNAPSHOT: 'Fund Snapshot',
    RISK_POTENTIAL: 'Risk Potential',
    VOLATILITY_AND_MEASURES: 'Volatility and Other Measures',
    YIELD_PERFORMANCE: 'Yield Performance',
    MONTHLY_DISTRIBUTION: 'Monthly Distribution'
};

export const FUND_TYPES = {
    BLENDED_ASSET: 'BLENDED_ASSET',
    BOND: 'BOND',
    MONEY_MARKET: 'MONEY_MARKET',
    STOCK: 'STOCK'
};

export const FUND_DOMAIN = {
    INTERNATIONAL: 'INTERNATIONAL',
    DOMESTIC: 'DOMESTIC'
};

export const TRANSPARENCY_TYPES = {
    FULL: 'Fully Transparent',
    SEMI: 'Semi-Transparent'
};

export const ETF_ASSET_CLASS_TYPES = {
    EQUITY: 'Equity',
    FIXED_INCOME: 'Fixed Income'
};

export const RUSSEL_FUNDS = [
    'DMG',
    'MCV',
    'NHF',
    'PSB',
    'PSI',
    'PSG',
    'SCS',
    'SCV',
    'SPG',
    'MVI'
];

export const NO_MSTR_FUNDS = ['AME', 'AMI', 'EEM', 'EEI'];

export const USHY_FUNDS = ['UHY'];

export const USHI_FUNDS = ['UHI'];

export const UH_FUNDS = USHY_FUNDS.concat(USHI_FUNDS);

export const NO_LIPPER = ['MSR', 'RFI', 'MRI'];

export const NO_DATA = `☠☠☠☠`;

export const US_EQUITY = [
    'PRWCX',
    'TRAIX',
    'RPMGX',
    'RPTIX',
    'OTCFX',
    'OTIIX',
    'PRVIX',
    'PRSVX',
    'TUHIX',
    'TUHYX'
];

export const navDisclaimer =
    '(For total standardized return as of the most recent calendar quarter end, click on the fund name.)';

export const CANONICAL_PATH =
    'https://www.troweprice.com/personal-investing/tools/fund-research';

export const RPS_ENTITLEMENT = 'TRP_RPS_EXTERNAL_USER_ACCESS';
export const II_ENTITLEMENT = 'TRP_RET_EXTERNAL_USER_ACCESS';
export const NON_GUEST_ENTITLEMENTS = [II_ENTITLEMENT, RPS_ENTITLEMENT];

export const ETF_TABLE_TYPES = {
    nav: 'NAV',
    marketPrice: 'Market Price'
};
